import { useMutation } from '@tanstack/react-query'

import { registerOrganization } from '@src/api'
import { DefaultApiRegisterOrganizationRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useRegisterOrganization = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiRegisterOrganizationRequest) =>
      registerOrganization(axiosInstance, params),
  })
}
